<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>仓库物料配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">物料名称:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.materialName"
                size="small"
                @keyup.enter.native="searchMaterial"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row" :offset="1">
            <div class="query-title">物料类别:</div>
            <div class="flex1">
              <el-select
                v-model="queryInfo.materialType"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="11" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">

              <el-button class="search-btn btn-gray" @click="clearConditions">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchMaterial">搜索</el-button>
              <el-button class="search-btn btn-green" @click="newMaterial">新增物料</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :header-cell-style="tableStyle.headerStyle"
                  :cell-style="tableStyle.cellStyle"
                  :data="materialList"
                  border
                  height="550"
                  >
          <el-table-column type="index" label="序号" align="center"  width="40">
          </el-table-column>
          <el-table-column prop="materialName" label="物料名称">
          </el-table-column>
          <el-table-column
            prop="materialType"
            label="物料类别"
            :formatter="typeFormatter"
          >
          </el-table-column>
          <el-table-column :index="indexMethod" align="center" sortable prop="amount" label="物料库存数量">
          </el-table-column>
          <el-table-column :index="indexMethod" sortable prop="price" align="center" label="物料价格">
          </el-table-column>
          <el-table-column
            prop="materialExplain"
            label="物料说明">
          </el-table-column>
          <el-table-column prop="sortKey" align="center" label="类别中的排序">
          </el-table-column>
          <el-table-column prop="useAmount" :index="indexMethod" align="center"  sortable label="历史用量">
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope" >
              <div class="btn-row">
                <el-button
                  class="list-btn-four btn-blue"
                  @click="editMaterial(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="list-btn-four btn-green"
                  @click="addMaterial(scope.row)"
                  >进料</el-button
                >
                <el-button
                  class="list-btn-four btn-blue"
                  @click="materialRecord(scope.row)"
                  >物料流水</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      @close="materialDialogClose"
    >
      <el-form
        label-width="120px"
        class="add-role-form"
        :model="materialDialog"
        :rules="dataRule"
        ref="dialogForm"
      >
        <el-form-item label="物料名称：" prop="materialName">
          <el-input
            v-model="materialDialog.materialName"
            size="small"
            :disabled="dialogType == 0 || dialogType == 1"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前数量：">
          <el-input
            v-model="materialDialog.currAmount"
            size="small"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="类别："
          v-if="dialogType == 0 || dialogType == 2"
          prop="materialType"
        >
          <div >
            <el-select
            v-model="materialDialog.materialType"
            placeholder="请选择"
            size="small"
            :disabled="dialogType == 0"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          </div>
        </el-form-item>
        <el-form-item
          label="物料说明："
          v-if="dialogType == 0 || dialogType == 2"
          prop="materialExplain"
        >
          <el-input
            v-model="materialDialog.materialExplain"
            size="small"

          ></el-input>
        </el-form-item>
        <el-form-item
          label="物料价格："
          v-if="dialogType == 0 || dialogType == 2"
          prop="price"
        >
          <el-input
            v-model="materialDialog.price"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序值："
          v-if="dialogType == 0 || dialogType == 2"
          prop="sortKey"
        >
          <el-input
            v-model.number="materialDialog.sortKey"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="进料数量：" v-if="dialogType == 1" prop="amount">
          <el-input
            v-model.number="materialDialog.amount"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" v-if="dialogType == 1" prop="note">
          <el-input
            v-model="materialDialog.note"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeMaterialDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmEdit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  name: 'wareMaterials',
  // name: 'configuration/WareMaterials',
  components: { tableCon },
  data() {
    return {
      dialogType: 0, //0 修改页面 1 进料页面 2 新增页面
      dialogTitle: "",
      typeOptions: [
        {
          value: "0",
          label: "箱子",
        },
        {
          value: "1",
          label: "OPP袋",
        },
      ],
      queryInfo: {
        materialName: "",
        materialType: "",
        pageSize: 10,
        pageNum: 1,
      },
      dataRule: {
        materialName: [
          { message: "物料名不能为空", trigger: "blur", required: true },
        ],
        materialType: [
          { message: "请选择物料类别", trigger: "change", required: true },
        ],
        materialExplain: [
          { message: "物料说明不能为空", trigger: "blur", required: true },
        ],
        price: [
          { message: "价格不能为空", trigger: "blur", required: true },
          {
            validator: (rule, value, callback) => {
              var reg = /^\d{1,16}(?:\.\d{1,2})?$/; //小数点左边最高16位，小数点右边最多2位
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("输入正确的数字,小数点后可1到2位"));
              }
            },
            trigger: "blur",
          },
        ],
        sortKey: [
          { message: "排序值不能为空", trigger: "blur", required: true },
          { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        amount: [
          { message: "进料数量不能为空", trigger: "blur", required: true },
          { type: "number", message: "必须为数字值", trigger: "blur" },
        ], //进料数量
        note: [{ message: "备注不能为空", trigger: "blur", required: true }], //备注
      },
      materialDialog: {
        id: 0,
        materialName: "",
        currAmount: 0,
        materialType: "",
        materialExplain: "",
        price: null,
        sortKey: 0,
        amount: null, //进料数量
        note: "", //备注
      },
      materialList: [],
      total: 0,
      dialogVisible: false,
    };
  },
  methods: {
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    materialRecord(row) {
      this.$router.push({
        name: "materialRecord",
        query: {
          materialId: row.id,
          materialName: row.materialName,
        },
      });
    },
    typeFormatter(row, column) {
      if (row.materialType == 0) {
        return "箱子";
      } else if (row.materialType == 1) {
        return "OPP袋";
      }
    },
    searchMaterial() {
      this.queryInfo.pageNum = 1;
      this.getMaterialList();
    },
    async confirmEdit() {
      var my = this;
      this.$refs.dialogForm.validate(async function (valid) {
        if (valid) {
          if (my.dialogType == 1) {
            const { data: res } = await my.$http.post(
              "/material/feedStock",
              my.materialDialog
            );
            if (res.code == 200) {
              my.$message({
                type: "success",
                message: res.message,
              });
              my.dialogVisible = false;
              my.getMaterialList();
            } else {
              my.$message.error(res.message);
            }
          } else {
            if (my.dialogType == 2) {
              my.materialDialog.id = 0;
            }
            const { data: res } = await my.$http.post(
              "/material/modifyOrAddMaterial",
              my.materialDialog
            );
            if (res.code == 200) {
              my.$message({
                type: "success",
                message: res.message,
              });
              my.dialogVisible = false;
              my.getMaterialList();
            } else {
              my.$message.error(res.message);
            }
          }
        }
      });
    },
    closeMaterialDialog() {
      this.dialogVisible = false;
    },
    dialogInit(){
     this.materialDialog.id = 0;
      this.materialDialog.materialName = "";
      this.materialDialog.currAmount = 0;
      this.materialDialog.materialType = "";
      this.materialDialog.materialExplain = "";
      this.materialDialog.price = null;
      this.materialDialog.sortKey = 0;
      this.materialDialog.amount = null;
      this.materialDialog.note = "";
    },
    materialDialogClose() {
    },
    newMaterial() {
      this.dialogInit();
      this.dialogType = 2;
      this.dialogTitle = "新增物料";
      let _this = this;
      this.$nextTick(function () {
         _this.$refs.dialogForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    addMaterial(row) {
      this.dialogInit();
      this.dialogType = 1;
      this.dialogTitle = "进料";
      this.dialogInitialize(row);
      let _this = this;
      this.$nextTick(function () {
         _this.$refs.dialogForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    editMaterial(row) {
      this.dialogInit();
      this.dialogType = 0;
      this.dialogTitle = "修改物料";
      this.dialogInitialize(row);
      let _this = this;
      this.$nextTick(function () {
         _this.$refs.dialogForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    dialogInitialize(row) {
      this.materialDialog.id = row.id;
      this.materialDialog.currAmount = row.amount;
      this.materialDialog.materialName = row.materialName;
      this.materialDialog.materialType = row.materialType;
      this.materialDialog.materialExplain = row.materialExplain;
      this.materialDialog.price = row.price;
      this.materialDialog.sortKey = row.sortKey;
    },
    handleSizeChange(pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getMaterialList();
    },
    handleCurrentChange(pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getMaterialList();
    },
    clearConditions() {
      this.queryInfo.userName = "";
      this.queryInfo.materialType = "";
      this.queryInfo.materialName = ''
    },
    async getMaterialList() {
      const { data: res } = await this.$http.get("material/materialList", {
        params: this.queryInfo,
      });
      this.materialList = res.data.list;
      this.total = res.data.total;
    },
  },

  created() {
    this.getMaterialList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
// .el-dialog{
//   height: 80% !important;
//   overflow: auto !important;
// }
</style>
